// Utility functions for Baserow filtering
export function buildMCQFilter(subtopicId: string) {
  return {
    'user_field_names': 'true',
    'size': '200', // Baserow limit per request
    'filter__SubTopic__single_select_equal': subtopicId,
    'filter__Compared__boolean': 'false',
    'filter__Duplicate__boolean': 'false'
  };
}

export function buildPaginationParams(page: number) {
  return {
    'page': page.toString(),
    'size': '200'
  };
}